import React, { useState, useCallback } from "react";
import { API } from "aws-amplify";

const apiName = "empaquesMayorgaApi";
const route = "/cotizacion";
export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [completed, setCompleted] = useState(false);

  const sendCotizationForm = useCallback(
    async ({
      name,
      business = "",
      email,
      phone,
      number,
      contractType,
      unitCost,
      total,
      design,
      genericDesign,
      includeStrategy,
    }) => {
      try {
        setLoading(true);
        const res = await API.post(apiName, route, {
          headers: {},
          body: {
            name,
            business,
            email,
            phone,
            number,
            contractType: contractType === "quarterly" ? "Trimestral" : "Única",
            unitCost: `$${unitCost
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
            design:
              design === "generic"
                ? `Genérico (${
                    genericDesign === "red"
                      ? "Rojo"
                      : genericDesign === "purple"
                      ? "Morado"
                      : "Naranja"
                  })`
                : "Personalizado",
            total: `$${total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
            includeStrategy: includeStrategy ? "Sí" : "No",
          },
        });

        setLoading(false);
        setCompleted(true);
      } catch (e) {
        setLoading(false);
        setError(true);
      }
    },
    []
  );

  return {
    sendCotizationForm,
    loading,
    error,
    completed,
  };
};
